import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Home = () => {
    return (
        <Box sx={{ p: 4 }}> 
            <Paper sx={{ p: 4, textAlign: 'center', borderRadius: 4 }} elevation={2}>  
                <Typography variant="h3" fontWeight="bold" gutterBottom>
                    Welcome to Dashboard
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    You can manage users, roles, categories, projects, and more from the sidebar.
                </Typography>
            </Paper>
        </Box>
    );
};

export default Home;
